import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getHeroEvents, getIsFetching } from 'Store/Banners/selectors';
import Hero from 'Components/Hero/Hero';

interface IPropsInternal {
  isFetching: boolean;
  heroEvents: Julius.Website.EventOverviewViewModel[];
}

type Props = IPropsInternal & RouteComponentProps<{}>;

class HeroContainer extends React.PureComponent<Props> {

  onEventClick = (eventID: number) => {
    this.props.history.push(`/events/${ eventID }`);
  }

  render() {
    return (
      <Hero
        isFetching={ this.props.isFetching }
        heroEvents={ this.props.heroEvents }
        onClick={ this.onEventClick }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    heroEvents: getHeroEvents(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(HeroContainer);


// WEBPACK FOOTER //
// ./src/components/Hero/HeroContainer.tsx